import { VehicleStatusEnum } from '@/services/api-clients';

export function vehicleStatusTextColorFilter(status: VehicleStatusEnum) {
  switch (status) {
    case VehicleStatusEnum.Available: return 'green--text';
    case VehicleStatusEnum.Busy: return 'red--text';
    case VehicleStatusEnum.InWorkshop: return 'indigo--text darken-4';
    case VehicleStatusEnum.ReceivingFromWorkshop: return 'indigo--text lighten-1';
    case VehicleStatusEnum.Theft: return 'red--text';
    default: return '';
  }
}
